import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Button from "components/ui/controls/button/button";
import { FaCalculator, FaSync, FaUnlock } from "react-icons/fa";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import InfoMessage from "components/ui/controls/info-message/info-message";
import Switch from "components/ui/controls/switch/Switch";

const MajorationEnfantRetraite = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <InfoMessage
              text={
                <>
                  Nous vous informons que les majorations enfants <b>sont attribuées par défaut au régime général. </b>
                  Toutefois, nous vous rappelons que lorsque qu'un assuré a cotisé au régime général et auprès d'un régime spécial (Fonction publique ou CRPCEN),
                  <b>c'est en principe le régime spécial qui accorde la majoration </b>
                  de trimestres si les conditions d'attribution sont remplies (ex : cessation d'activité…). Pour tenir compte de ces règles, vous pouvez modifier manuellement la majoration
                  dans les différents régimes.
                </>
              }
            />
            <Row tpad>
              <Column fill>
                <div className="header-card">
                  <div className="category-column" style={{flex:1}}>
                    <span className="header-icon">💼</span>
                    Régimes
                  </div>
                  <div className="value-column">
                    <span className="header-icon">📅</span>
                    Date de naissance
                  </div>
                  <div className="value-column">
                    <span className="header-icon">📊</span>
                    Nombre de trimestres
                  </div>
                </div>
                <div className="card-list-container">
                  <div className="card">
                    <div className="category-column" style={{flex:1}}>
                      <div className="titre-icone">📋</div>
                      Régime général
                    </div>
                    <div className="value-column">-</div>
                    <div className="value-column">
                      <TextField
                        hideIconInLabel
                        iconBefore={
                          <Button
                            icon
                            onClick={(e) => {
                              context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisi" + ClientConjoint, ClientConjoint, "");
                            }}
                            {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                          >
                            {!context.state["CarriereMajorationEnfantSaisi" + ClientConjoint] ? (
                              <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                            ) : (
                              <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                            )}
                          </Button>
                        }
                        value={context.state["CarriereMajorationEnfant" + ClientConjoint]}
                        onKeyUp={(e) => {
                          context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisi" + ClientConjoint, ClientConjoint, e.target.value);
                        }}
                        onChange={context.handleInputChange("CarriereMajorationEnfant" + ClientConjoint)}
                        dataType="uint"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-list-container" style={{ marginTop: "8px" }}>
                  <div className="card">
                    <div className="category-column" style={{flex:1}}>
                      <div className="titre-icone">📋</div>
                      Fonction publique
                    </div>
                    <div className="value-column">Enfants nés avant 2004</div>
                    <div className="value-column">
                      <TextField
                        hideIconInLabel
                        iconBefore={
                          <Button
                            icon
                            onClick={(e) => {
                              context.handleCarriereMajorationEnfantSaisi("TrimestreBonificationEnfantSaisiFonctionPublique" + ClientConjoint, ClientConjoint, "");
                            }}
                            {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                          >
                            {!context.state["TrimestreBonificationEnfantSaisiFonctionPublique" + ClientConjoint] ? (
                              <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                            ) : (
                              <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                            )}
                          </Button>
                        }
                        value={context.state["TrimestreBonificationEnfantFonctionPublique" + ClientConjoint]}
                        onKeyUp={(e) => {
                          context.handleCarriereMajorationEnfantSaisi("TrimestreBonificationEnfantSaisiFonctionPublique" + ClientConjoint, ClientConjoint, e.target.value);
                        }}
                        onChange={context.handleInputChange("TrimestreBonificationEnfantFonctionPublique" + ClientConjoint)}
                        dataType="uint"
                      />
                    </div>
                  </div>
                  <div className="card">
                    <div className="category-column" style={{flex:1}}>
                      <div className="titre-icone">📋</div>
                      Fonction publique
                    </div>
                    <div className="value-column">Enfants nés à partir de 2004</div>
                    <div className="value-column">
                      <TextField
                        hideIconInLabel
                        iconBefore={
                          <Button
                            icon
                            onClick={(e) => {
                              context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisiFonctionPublique" + ClientConjoint, ClientConjoint, "");
                            }}
                            {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                          >
                            {!context.state["CarriereMajorationEnfantSaisiFonctionPublique" + ClientConjoint] ? (
                              <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                            ) : (
                              <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                            )}
                          </Button>
                        }
                        value={context.state["CarriereMajorationEnfantFonctionPublique" + ClientConjoint]}
                        onKeyUp={(e) => {
                          context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisiFonctionPublique" + ClientConjoint, ClientConjoint, e.target.value);
                        }}
                        onChange={context.handleInputChange("CarriereMajorationEnfantFonctionPublique" + ClientConjoint)}
                        dataType="uint"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-list-container" style={{ marginTop: "8px" }}>
                  <div className="card">
                    <div className="category-column" style={{flex:1}}>
                      <div className="titre-icone">📋</div>
                      CRPCEN
                    </div>
                    <div className="value-column">Enfants nés avant juillet 2006</div>
                    <div className="value-column">
                      <TextField
                        hideIconInLabel
                        iconBefore={
                          <Button
                            icon
                            onClick={(e) => {
                              context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisiCrpcen" + ClientConjoint, ClientConjoint, "");
                            }}
                            {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                          >
                            {!context.state["CarriereMajorationEnfantSaisiCrpcen" + ClientConjoint] ? (
                              <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                            ) : (
                              <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                            )}
                          </Button>
                        }
                        value={context.state["CarriereMajorationEnfantCrpcen" + ClientConjoint]}
                        onKeyUp={(e) => {
                          context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisiCrpcen" + ClientConjoint, ClientConjoint, e.target.value);
                        }}
                        onChange={context.handleInputChange("CarriereMajorationEnfantCrpcen" + ClientConjoint)}
                        dataType="uint"
                      />
                    </div>
                  </div>
                  <div className="card">
                    <div className="category-column" style={{flex:1}}>
                      <div className="titre-icone">📋</div>
                      CRPCEN
                    </div>
                    <div className="value-column">Enfants nés à partir de juillet 2006</div>
                    <div className="value-column">
                      <TextField
                        hideIconInLabel
                        iconBefore={
                          <Button
                            icon
                            onClick={(e) => {
                              context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisiCrpcenApres2006" + ClientConjoint, ClientConjoint, "");
                            }}
                            {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                          >
                            {!context.state["CarriereMajorationEnfantSaisiCrpcenApres2006" + ClientConjoint] ? (
                              <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                            ) : (
                              <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                            )}
                          </Button>
                        }
                        value={context.state["CarriereMajorationEnfantCrpcenApres2006" + ClientConjoint]}
                        onKeyUp={(e) => {
                          context.handleCarriereMajorationEnfantSaisi("CarriereMajorationEnfantSaisiCrpcenApres2006" + ClientConjoint, ClientConjoint, e.target.value);
                        }}
                        onChange={context.handleInputChange("CarriereMajorationEnfantCrpcenApres2006" + ClientConjoint)}
                        dataType="uint"
                      />
                    </div>
                  </div>
                </div>
              </Column>
            </Row>
            <Row tpad>
              <Column fill>
                <div
                  style={{
                    background: "#f0f9ff",
                    border: "1px solid #bae6fd",
                    borderRadius: "12px",
                    padding: "20px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "white",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        color: "#0369a1",
                        flexShrink: 0,
                      }}
                    >
                      <FaUnlock size={18} />
                    </div>

                    <div style={{ flex: 1 }}>
                      <div style={{ marginBottom: "12px" }}>
                        <Switch
                          checked={context.state["UnlockMajoEnfantAgircArrco" + ClientConjoint]}
                          onChange={(checked) => context.handleCheckChange("UnlockMajoEnfantAgircArrco" + ClientConjoint)(null, checked)}
                          label="Calcul de la majoration enfant AGIRC ARRCO"
                          color="primary"
                          size="sm"
                        />
                      </div>

                      <InfoMessage
                        text={
                          <>
                            <b>Le calcul des majorations enfant à l'AGIRC-ARRCO n'est pas lancé automatiquement.</b> En effet, le RIS ne permet pas de distinguer les points ARRCO des points
                            AGIRC et c'est pourquoi le logiciel intègre les points acquis dans les points AGIRC-ARRCO à compter de 2019. Or, les taux de majoration des points dépendent du
                            régime et de la date d'acquisition. Si vous souhaitez intégrer le calcul des majorations enfant, nous vous conseillons vivement de disposer d'un ancien relevé de
                            points AGIRC ARRCO.
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
};
export default MajorationEnfantRetraite;
